import type en from '../en/monitoring'
import type { Translation } from '../types'

/** Monitoring and alerts */
const monitoring: Translation<typeof en> = {
  "monitoring.subtitle": "Actuele status van alle locaties",
  "monitoring.online": "Online",
  "monitoring.warning": "Waarschuwing",
  "monitoring.offline": "Offline",
  "monitoring.awaitingVpn": "Wacht op VPN",
  "monitoring.noData": "Geen gegevens",
  "monitoring.lastSeen": "Laatst gezien {when}",
  "monitoring.alertsActive": { one: "{count} actieve melding", other: "{count} actieve meldingen" },
  "monitoring.alertsResolved": { one: "{count} opgeloste melding", other: "{count} opgeloste meldingen" },
  "monitoring.active": "Actief",
  "monitoring.resolved": "Opgelost",
  "monitoring.noResolved": "Geen opgeloste meldingen",
  "monitoring.allClear": "Alles in orde!",
  "monitoring.noneResolvedYet": "Er zijn nog geen meldingen opgelost.",
  "monitoring.healthy": "Geen actieve meldingen — uw netwerk is in orde.",
  "monitoring.acknowledge": "Bevestigen",
  "monitoring.acknowledged": "✓ Bevestigd",
  "monitoring.resolvedWhen": "✓ Opgelost {when}",
  "monitoring.category.VPN": "VPN",
  "monitoring.category.cellular": "mobiel",
  "monitoring.category.device": "apparaat",
  "monitoring.category.firmware": "firmware",
  "monitoring.category.license": "licentie",
  "monitoring.category.link": "verbinding",
  "monitoring.category.speedfusion": "speedfusion",
  "monitoring.category.sync": "synchronisatie",
  "monitoring.category.wan": "wan",
  "monitoring.category.wifi": "wifi",
}

export default monitoring
